import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { PluckingChecklistBPLReportSchema } from "../PluckingChecklistBPLReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import CreatePdf from './createPdf';
import ReactToPrint from "react-to-print";
import '../../../Common/Table/table.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import { InputAdornment, Box } from '@material-ui/core';
import Search from '@mui/icons-material/Search';
import _ from 'lodash';

const screenCode = 'PLUCKINGCHECKLISTBPLREPORT'

export function PluckingChecklistBPLReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState([]);
    const [subNames, setSubNames] = useState([]);
    const [unitNames, setUnitNames] = useState([])
    const [colName, setColName] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "",
        operationEntityID: "",
        collectionPointID: "",
        pluckingType: "0",
        date: "",
    });
    const [customSearch, setCustomSearch] = useState({
        regNumber: ''
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        operationEntity: "",
        collectionPoint: "",
        pluckingType: "",
        field: "",
        date: "",
    });
    const [summeryValues, setSummeryValues] = useState({
        full: 0,
        half: 0,
        bellow: 0,
        allTotal: 0,
        okTot: 0,
        totMan: 0
    });
    const [totalValues, setTotalValues] = useState({
        totalOverKg: 0,
        totalDay: 0
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(PluckingChecklistBPLReportSchema).options({ allowUnknown: true });

    const [csvHeaders, setCsvHeaders] = useState([]);

    const [data, setdata] = useState([]);
    const [data1, setdata1] = useState([]);
    const [summeryData, setSummeryData] = useState([]);
    const [summaryUnits, setSummaryUnits] = useState([])
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [hideSearch, setHideSearch] = useState(true)
    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
        resetDropDowns(DropdownChanges.group);
    }, [searchData.groupID])

    useEffect(() => {
        if (searchData.operationEntityID > 0) {
            trackPromise(
                getCollectionCategoryForDropDown()
            )
            getCollectionPointsForDropDown();
            resetDropDowns(DropdownChanges.operationEntity);
        }
    }, [searchData.operationEntityID])

    useEffect(() => {
        handleSearch1(customSearch.regNumber);
    }, [customSearch.regNumber]);

    useEffect(() => {
        if (data.length != 0) {
            calculateTotal()
        }
    }, [data]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPLUCKINGCHECKLISTBPLREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setsearchData({
                ...searchData,
                groupID: token.groupID
            });

        } else {
            setsearchData({
                ...searchData,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    function resetDropDowns(type) {
        if (type === DropdownChanges.operationEntity) {
            setsearchData({
                ...searchData,
                collectionPointID: "0",
            });
        } else if (type === DropdownChanges.group) {
            setsearchData({
                ...searchData,
                operationEntityID: "0",
                collectionPointID: "0",
            });
        }
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategory = await service.getCollectionCategoryByOperationEntityForDropDown(searchData.operationEntityID);
        setCollectionCategory(collectionCategory);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;
        const error = { ...errors };
        const errorMessage = validateProperty(target, PluckingChecklistBPLReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
        clearTableRelatedData();
    }

    async function handleSearch(e) {
        e.preventDefault();

        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        let result = await service.getReportData(searchData.collectionPointID, searchData.pluckingType, searchData.date);
        formatResult(result);
        getSelectedDropdownValuesForReport(searchData);
        if (result.length > 0) {
            setHideSearch(false)
        } else {
            setHideSearch(true)
        }
    }

    function formatResult(data) {
        var result = [];
        var totalOfAllrecords = 0;
        let totalOfUnits = 0
        var names = [];
        let unitNames = []
        var csvHeaders = [
            { label: "Reg Number", value: "registrationNumber" },
            { label: "Employee Name", value: "firstName" },
            { label: "Field", value: "fieldName" },
        ];
        data.forEach(x => {
            var sessionName = x.sessionName;
            var sessionForUnit = x.sessionName + 'UN'
            if (result.length === 0) {
                result.push({
                    [sessionForUnit]: checkUndifind(x.numberOfUnits),
                    [sessionName]: checkUndifind(x.totalAmount),
                    employeeID: parseInt(x.employeeID),
                    registrationNumber: x.registrationNumber,
                    firstName: x.firstName,
                    total: checkUndifind(x.totalAmount),
                    configurationValue: x.configurationValue,
                    maxValue: x.maxValue,
                    minValue: x.minValue,
                    fieldName: x.fieldName,
                    isHolidayOrSunday: x.isHolidayOrSunday,

                });
                names.push(x.sessionName);
                unitNames.push(x.sessionName + 'UN')
                csvHeaders.push({ label: x.sessionName, value: x.sessionName });
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.totalAmount);
                totalOfUnits = totalOfUnits + x.numberOfUnits
            } else {
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.totalAmount);
                totalOfUnits = totalOfUnits + x.numberOfUnits
                var duplicate = result.find(y => parseInt(y.employeeID) == parseInt(x.employeeID));

                var duplicateName = names.find(y => y === x.sessionName);

                if (!duplicateName) {
                    names.push(x.sessionName);
                    unitNames.push(x.sessionName + 'UN')
                    csvHeaders.push({ label: x.sessionName, value: x.sessionName });
                }

                if (duplicate) {
                    duplicate[sessionName] = checkUndifind(duplicate[sessionName]) + checkUndifind(x.totalAmount);
                    duplicate[sessionName + 'UN'] = checkUndifind(duplicate[sessionName + 'UN']) + checkUndifind(x.numberOfUnits)
                    duplicate.registrationNumber = x.registrationNumber;
                    duplicate.firstName = x.firstName;
                    duplicate.configurationValue = x.configurationValue;
                    duplicate.maxValue = x.maxValue;
                    duplicate.minValue = x.minValue;
                    duplicate.fieldName = x.fieldName;
                    duplicate.isHolidayOrSunday= x.isHolidayOrSunday;
                    duplicate.total = checkUndifind(duplicate.total) + checkUndifind(x.totalAmount);
                } else {
                    result.push({
                        [sessionName]: checkUndifind(x.totalAmount),
                        [sessionName + 'UN']: checkUndifind(x.numberOfUnits),
                        employeeID: parseInt(x.employeeID),
                        registrationNumber: x.registrationNumber,
                        firstName: x.firstName,
                        total: checkUndifind(x.totalAmount),
                        configurationValue: x.configurationValue,
                        maxValue: x.maxValue,
                        minValue: x.minValue,
                        fieldName: x.fieldName,
                        isHolidayOrSunday: x.isHolidayOrSunday,
                    });
                }
            }
        });
        names.sort((a, b) => a > b ? 1 : -1);
        unitNames.sort((a, b) => a > b ? 1 : -1);

        csvHeaders.push({ label: "Total", value: "total" });
        if (searchData.pluckingType == 'GENERAL') {
            csvHeaders.push({ label: "Mandays", value: "duration" });
            csvHeaders.push({ label: "Cash Kilo", value: "overKilo" });
        }

        var result2 = [];
        let resultUN1 = []
        result.forEach(x => {
            names.forEach(y => {
                if (x[y]) {
                    result2.push({
                        property: y,
                        value: checkUndifind(x[y])
                    });
                }
            });
        });

        result.forEach(x => {
            unitNames.forEach(y => {
                if (x[y]) {
                    resultUN1.push({
                        property: y,
                        value: checkUndifind(x[y])
                    });
                }
            });
        });
        const result3 = result2.reduce((obj, el) => {
            obj[el.property] = (obj[el.property] || 0) + el.value;
            return obj;
        }, {});

        const resultUN2 = resultUN1.reduce((obj, el) => {
            obj[el.property] = (obj[el.property] || 0) + el.value;
            return obj
        }, {})

        const result4 = result.filter(x => x.total >= x.configurationValue);
        const result5 = result.filter(x => x.total < x.configurationValue && x.total >= x.configurationValue / 2);
        const result6 = result.filter(x => x.total < (x.configurationValue / 2));
        let okTot = 0;
        let totMan = 0;
        result.forEach(x => {
            if ((parseFloat(x.total) < parseFloat(x.configurationValue) / 2)) {
                //okTot = okTot + parseFloat(x.total);
            }
            else if ((parseFloat(x.total) - parseFloat(x.configurationValue)) < 0) {
                okTot = okTot + (parseFloat(x.total) - parseFloat(x.configurationValue) / 2)
            }
            else {
                okTot = okTot + (parseFloat(x.total) - parseFloat(x.configurationValue));
            }
            totMan = totMan + (parseFloat(x.total) < (parseFloat(x.configurationValue) / 2) ? 0 : (parseFloat(x.total) >= parseFloat(x.configurationValue)) ? 1 : 0.5);
        });

        setSummeryValues({
            ...summeryValues,
            full: result4.length,
            half: result5.length,
            bellow: result6.length,
            allTotal: totalOfAllrecords,
            totMan: totMan,
            okTot: okTot,
            totalOfUnits: totalOfUnits
        });

        setCsvHeaders(csvHeaders);
        setSubNames(names);
        setdata(result);
        setdata1(result);
        setCsvData(result);
        setColName(names);
        setUnitNames(unitNames)

        var resultqqqq = Object.entries(result3);
        let resultun = Object.entries(resultUN2)

        var temlArry = [];
        let temlArry2 = [];

        for (const key in resultqqqq) {
            temlArry.push({
                name: resultqqqq[key][0],
                value: resultqqqq[key][1]
            })
        }
        for (const key in resultun) {
            temlArry2.push({
                name: resultun[key][0],
                value: resultun[key][1]
            })
        }
        temlArry.sort((a, b) => a.name > b.name ? 1 : -1);
        setSummeryData(temlArry);
        setSummaryUnits(temlArry2)
    }

    function checkUndifind(value) {
        if (value === undefined) {
            return 0;
        }
        else {
            return value;
        }
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntity[searchForm.operationEntityID],
            collectionPoint: collectionPoint[searchForm.collectionPointID],
            pluckingType: searchForm.pluckingType,
            date: searchForm.date
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function onCancelClick() {
        setsearchData({
            ...searchData,
            collectionPointID: "0",
            pluckingType: "0",
            date: ""
        });

        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setdata([]);
        setIsTableHide(true);
        setSelectedSearchValues([]);
    }

    function handleChange1(e) {
        const target = e.target;
        const value = target.value
        setCustomSearch({
            ...customSearch,
            regNumber: value
        });
    }

    async function handleSearch1(data2) {
        if (data == null || data.length == 0) {
            setdata(data1)
        }
        const Default = data.filter(x => x.registrationNumber.toLowerCase().includes(data2.toLowerCase()) || x.firstName.toLowerCase().includes(data2.toLowerCase()))
        if (data2 == '') {
            setdata(data1)
            return;
        }
        setdata(Default)
    }

    const getOverKg = (row) => {
        const total = parseFloat(row.total);
        const maxValue = parseInt(row.maxValue);
        const minValue = parseInt(row.minValue);
        const isHolidayOrSunday = parseInt(row.isHolidayOrSunday);
        let overKg;
        let day;
        let isCashKilo = false;
        if(isHolidayOrSunday==1 ||  maxValue==minValue) {
            if (total >= maxValue) {
                overKg = (total - maxValue).toFixed(2);
                day = maxValue.toFixed(2);
            } else if (total < maxValue) {
                overKg = Math.floor(total).toFixed(2);
                day = Math.ceil(maxValue / 2).toFixed(2);
                isCashKilo = true;
            }
        }
        else{
            if (total >= maxValue) {
                overKg = (total - maxValue).toFixed(2);
                day = maxValue.toFixed(2);
            } else if (total >= minValue && total <= maxValue) {
                overKg = (0).toFixed(2);
                day = total.toFixed(2);
            } else if (total <= minValue && total >= (maxValue / 2)) {
                overKg = Math.floor(total - (maxValue / 2)).toFixed(2);
                day = Math.ceil(maxValue / 2).toFixed(2);
                isCashKilo = true;
            } else if (total < (maxValue / 2)) {
                overKg = (total).toFixed(2);
                day = (0).toFixed(2);
            } else {
                overKg = (0).toFixed(2);
                day = (0).toFixed(2);
            }
        }

        return { overKg, day, isCashKilo };
    };
    function calculateTotal() {

        const totalOverKg = data.reduce((accumulator, current) => {
            const overKgTotal = parseFloat(getOverKg(current).overKg);
            return accumulator + overKgTotal;
        }, 0);

        const totalDay = data.reduce((accumulator, current) => {
            const dayTotal = parseFloat(getOverKg(current).day);
            return accumulator + dayTotal;
        }, 0);

        setTotalValues({
            ...totalValues,
            totalOverKg: totalOverKg,
            totalDay: totalDay
        });
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Plucking Checklist BPL Report"
                                isButtonEnable={false}
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {generateDropDownMenu(multipleEstates.length == 0 ? operationEntity : multipleEstates)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection point *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="pluckingType">Plucking Type *</InputLabel>
                                    <Select
                                        id="pluckingType"
                                        select
                                        fullWidth
                                        name="pluckingType"
                                        onChange={(e) => handleChange(e)}
                                        value={searchData.pluckingType}>
                                        <MenuItem value="0">--Select Plucking Type--</MenuItem>
                                        <MenuItem value="GENERAL">General</MenuItem>
                                        <MenuItem value="RSM">Outgrower</MenuItem>
                                        <MenuItem value="CASH">Cash</MenuItem>
                                        <MenuItem value="KILO">Kilo</MenuItem>
                                    </Select>
                                    {errors["pluckingType"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["pluckingType"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="searchDate">Date *</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="date"
                                        name="date"
                                        type="date"
                                        value={searchData.date}
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                </div>
                                <div className="col-md pb-1">

                                </div>

                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={validate(schema, searchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                        hidden={searchButtonHide}
                                    />
                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </div>
                        </form>
                        {hideSearch ? '' :
                            <Box display="flex" flexDirection="row-reverse" p={2} >
                                <TextField
                                    size="small"
                                    style={{ width: '300px' }}
                                    value={customSearch.regNumber}
                                    placeholder="Search"
                                    onChange={(e) => { handleChange1(e) }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                        }
                        {data.length != 0 ?
                            <Card>
                                <TableContainer component={Paper}>
                                    <div className="row alternative_cls bg-light  ">
                                        <div className="card-body width1" style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '20px', marginTop: '20px' }}>
                                        </div>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>

                                                    </TableCell>
                                                    <TableCell align="left" colSpan={7} style={{ fontWeight: "bold", width: "250px" }}>
                                                        Plucking Check List
                                                    </TableCell>
                                                    <TableCell align="left" colSpan={4} style={{ fontWeight: "bold", width: "250px" }}>
                                                        {searchData.pluckingType === "RSM" ? "Outgrower" : searchData.pluckingType}
                                                    </TableCell>

                                                </TableRow>
                                                <TableRow>
                                                    <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>

                                                    </TableCell>

                                                    <TableCell align="left" colSpan={3} style={{ fontWeight: "bold", width: "250px" }}>
                                                        Initial of Field Officer
                                                    </TableCell>
                                                    <TableCell align="left" colSpan={2} style={{ fontWeight: "bold", width: "250px" }}>

                                                    </TableCell>
                                                    <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>
                                                        Norm / Task
                                                    </TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>

                                                    </TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                        Date
                                                    </TableCell>
                                                    <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>
                                                        {searchData.date}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>

                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", width: "150px" }}>
                                                        Estate
                                                    </TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                        {selectedSearchValues.operationEntity}
                                                    </TableCell>
                                                    <TableCell align="left" colSpan={10} style={{ fontWeight: "bold" }}>
                                                        Name and Initial of Field Asst.
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>

                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Division
                                                    </TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                        {selectedSearchValues.collectionPoint}
                                                    </TableCell>
                                                    <TableCell align="left" colSpan={6} style={{ fontWeight: "bold" }}>
                                                        No .of Workers at Muster : {data.length}
                                                    </TableCell>

                                                    <TableCell align="left" colSpan={4} style={{ fontWeight: "bold" }}>
                                                        Muster Distributed by :
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>

                                                    </TableCell>
                                                    <TableCell align="left" colSpan={6} style={{ fontWeight: "bold" }}>
                                                        Field Officer :
                                                    </TableCell>

                                                    <TableCell align="left" colSpan={6} style={{ fontWeight: "bold" }}>
                                                        Supervisor
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        E.P.F. No.
                                                    </TableCell>
                                                    <TableCell align="center" colSpan={1} style={{ fontWeight: "bold" }}>
                                                        Name
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Field No.
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        1st Wt.
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        2nd Wt.
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        3rd Wt.
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        4th Wt.
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        OK / CK
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Day
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        O/T Hours
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {data.map((row, index) => {
                                                    const { overKg, day, isCashKilo } = getOverKg(row);

                                                    return (
                                                        <TableRow
                                                            key={row.registrationNumber}
                                                            style={isCashKilo && searchData.pluckingType == "GENERAL" ? { background: "#C8EDBE" } : {}}
                                                        >

                                                            <TableCell component="th" align="center">
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {row.registrationNumber}
                                                            </TableCell>
                                                            <TableCell align="left">
                                                                {row.firstName}
                                                            </TableCell>
                                                            <TableCell align="left">
                                                                {row.fieldName}
                                                            </TableCell>
                                                            {subNames.map((column) => {
                                                                const value = row[column];
                                                                return (
                                                                    <TableCell align='right'>{value == undefined ? ' ' : parseFloat(value).toFixed(2)}</TableCell>
                                                                );
                                                            })}
                                                            {subNames.length < 1 ? <TableCell align="center"></TableCell> : ''}
                                                            {subNames.length < 2 ? <TableCell align="center"></TableCell> : ''}
                                                            {subNames.length < 3 ? <TableCell align="center"></TableCell> : ''}
                                                            {subNames.length < 4 ? <TableCell align="center"></TableCell> : ''}
                                                            {searchData.pluckingType == 'GENERAL' ?
                                                                //     <TableCell align="center">{parseFloat(row.total) < parseFloat(row.configurationValue) / 2
                                                                //         ? 0
                                                                //         : (parseFloat(row.total) - parseFloat(row.configurationValue) < 0
                                                                //             ? (parseFloat(row.total) - parseFloat(row.configurationValue) / 2).toFixed(2)
                                                                //             : (parseFloat(row.total) - parseFloat(row.configurationValue)).toFixed(2))}</TableCell> :
                                                                //     <TableCell align="center"></TableCell>}
                                                                // {row.total ? <TableCell align="right">{row.total.toFixed(2)}</TableCell> : <TableCell align="right"></TableCell>}

                                                                <TableCell align="right">
                                                                    {getOverKg(row).overKg}
                                                                </TableCell> :
                                                                <TableCell align="right"></TableCell>}
                                                            {/* {row.total ? <TableCell align="right">{row.total.toFixed(2)}</TableCell> : <TableCell align="right"></TableCell>} */}
                                                            {searchData.pluckingType == 'GENERAL' ?
                                                                (row.total ? <TableCell align="right">{getOverKg(row).day}</TableCell> : <TableCell align="right"></TableCell>) :
                                                                (row.total ? <TableCell align="right">{row.total.toFixed(2)}</TableCell> : <TableCell align="right"></TableCell>)}
                                                            <TableCell align="center"></TableCell>
                                                            <TableCell align="center"></TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                    </TableCell>
                                                    <TableCell colSpan={3} style={{ fontWeight: "bold" }} align="center">
                                                        Total
                                                    </TableCell>
                                                    {summeryData.map((item) => (
                                                        <TableCell style={{ fontWeight: "bold" }} align="right">
                                                            {parseFloat(item.value).toFixed(2)}
                                                        </TableCell>
                                                    ))}
                                                    {subNames.length < 1 ? <TableCell align="center"></TableCell> : ''}
                                                    {subNames.length < 2 ? <TableCell align="center"></TableCell> : ''}
                                                    {subNames.length < 3 ? <TableCell align="center"></TableCell> : ''}
                                                    {subNames.length < 4 ? <TableCell align="center"></TableCell> : ''}
                                                    {searchData.pluckingType == 'GENERAL' ?
                                                        <TableCell style={{ fontWeight: "bold" }} align="right">
                                                            {/* {parseFloat(summeryValues.okTot).toFixed(2)} */}
                                                            {parseFloat(totalValues.totalOverKg).toFixed(2)}
                                                        </TableCell> : <TableCell></TableCell>}
                                                    {/* <TableCell style={{ fontWeight: "bold" }}>{summeryValues != undefined ? summeryValues.allTotal.toFixed(2) : ''}</TableCell> */}
                                                    {searchData.pluckingType == 'GENERAL' ?
                                                        <TableCell style={{ fontWeight: "bold" }} align="right">{parseFloat(totalValues.totalDay).toFixed(2)}</TableCell> :
                                                        <TableCell style={{ fontWeight: "bold" }} align="right">{summeryValues != undefined ? summeryValues.allTotal.toFixed(2) : ''}</TableCell>}

                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        G.Leaf wt.
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        No. of Bags
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell colSpan={7} style={{ fontWeight: "bold" }} align="center">
                                                        Checked by Supdt. / Asst. Supdt./ Field Officer
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow >
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        1 st
                                                    </TableCell>
                                                    <TableCell>{summeryData[0] != undefined ? summeryData[0].value.toFixed(2) : ''}</TableCell>
                                                    <TableCell>{summaryUnits[0] != undefined ? summaryUnits[0].value : ''}</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        Plkrs at PM Check
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell colSpan={2} style={{ fontWeight: "bold" }} align="center">
                                                        Checked by :
                                                    </TableCell>
                                                    <TableCell colSpan={3} ></TableCell>
                                                </TableRow>
                                                <TableRow >
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        2 nd
                                                    </TableCell>
                                                    <TableCell>{summeryData[1] != undefined ? summeryData[1].value.toFixed(2) : ''}</TableCell>
                                                    <TableCell>{summaryUnits[1] != undefined ? summaryUnits[1].value : ''}</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        Plkrs at AM Check
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell colSpan={3} style={{ fontWeight: "bold" }} align="center">
                                                        Name & Designation
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        Time
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        Initial
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow >
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        3 rd
                                                    </TableCell>
                                                    <TableCell>{summeryData[2] != undefined ? summeryData[2].value.toFixed(2) : ''}</TableCell>
                                                    <TableCell>{summaryUnits[2] != undefined ? summaryUnits[2].value : ''}</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        No.of Kanganies AM
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell colSpan={3} style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                </TableRow>
                                                <TableRow >
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell>{summeryData[3] != undefined ? summeryData[3].value.toFixed(2) : ''}</TableCell>
                                                    <TableCell>{summaryUnits[3] != undefined ? summaryUnits[3].value : ''}</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        No.of Kanganies PM
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell colSpan={3} style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                </TableRow>
                                                <TableRow >
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        Total
                                                    </TableCell>
                                                    <TableCell>{summeryValues != undefined ? summeryValues.allTotal.toFixed(2) : ''}</TableCell>
                                                    <TableCell>{summeryValues != undefined ? summeryValues.totalOfUnits : ''}</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        No.of Sack Labrs
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell colSpan={3} style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </div>
                                </TableContainer>
                            </Card>
                            : null}
                    </div>
                    {data.length != 0 ?
                        <div className="pt-2">
                            <ReactToPrint
                                documentTitle={"Plucking Checklist BPL Report"}
                                trigger={() => <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="PDF"

                                />}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePdf ref={componentRef} searchData={selectedSearchValues} contentRowNames={subNames} data={data} totalValues={totalValues}
                                    initialData={colName} summeryValues={summeryValues} summeryData={summeryData} selectedSearchValues={selectedSearchValues} unitNames={unitNames} summaryUnits={summaryUnits}
                                />
                            </div>
                        </div>
                        : null}
                </div>
            </div>
        </Fragment >
    );
}



